
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { makeKey } from '@/utils/qiniu';

import { addOrderBBS, getOrderBBS } from '@/api/order';
import { getOrderServiceBBSList } from '@/api/orderService';
import { UserModule } from '../../store/modules/user';
import { complain } from '../../api/orderComplaint';
import { ComplaintModule, ComplaintState } from '@/store/modules/complaint';

@Component({
  name: 'bbsDialog'
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  bbsDialogVisible!: Boolean;

  @Prop({
    type: Number,
    default: -1
  })
  nowId!: Number;

  @Prop({
    type: Number,
    default: -1
  })
  nowSid!: Number;

  @Prop({
    type: Number,
    default: -1
  })
  nowTid!: Number;

  @Prop({
    type: Number,
    default: -1
  })
  orderState!: Number;
  @Prop({
    type: Number,
    default: -1
  })
  complaintState!: Number;

  @Prop({
    type: Number,
    default: 0
  })
  viewType!: Number;

  private defaultImgUrl = 'this.src="' + require('@/assets/images/default-avatar.png') + '"'

  private bbsList: any[] = [];
  private bbsBtn: boolean = false;

  private qiniu: any;
  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private form: object = {};
  private bbsMessage: string = '';
  private bbsImage: string = '';
  private selfUser: number = UserModule.getUserId;

  get title() {
    return this.complaintState === -1 ? '留言' : '投诉';
  }
  created() {
    this.getBbsList();
  }

  /**
   * 留言
   */
  bbsOrderSubmit(type: number) {
    let params = {
      bbs_type: this.complaintState === -1 ? 0 : 1,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_name: UserModule.getCompanyName,
      user_avatar: (UserModule.user as any).avatar_new,
      order_id: this.nowId,
      order_service_id: this.nowSid,
      type: type,
      bbs_message: this.bbsMessage,
      bbs_image: this.bbsImage,
      bbs_audio: '',
      bbs_video: ''
    };
    addOrderBBS(params)
      .then((res) => {
        if (res.data) {
          this.bbsMessage = '';
          this.bbsImage = '';
          this.getBbsList();
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }

  getBbsList() {
    const params = {
      bbs_type: this.complaintState === -1 ? 0 : 1,
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      order_id: this.nowId,
      order_service_id: this.nowSid,
      order_task_id: this.nowTid
    };
    if (this.complaintState === -1) {
      // 没有传complainState参数，说明是在留言模块
      if ([1, 2, 3, 5].includes(this.orderState.valueOf())) {
        this.bbsBtn = true;
      } else {
        this.bbsBtn = false;
      }
    } else {
      let item = ComplaintModule.list.find(
        (item) => item.id === this.nowId.valueOf()
      );
      if (item === undefined) {
        item = {
          id: this.nowId.valueOf(),
          stage: this.complaintState.valueOf()
        };
        ComplaintModule.addItem(item);
      }
      if (item.stage !== 8 && this.orderState !== 88) {
        this.bbsBtn = true;
      } else {
        this.bbsBtn = false;
      }
    }
    if (this.viewType === 0) {
      getOrderBBS(params)
        .then((res) => {
          if (res.data) {
            this.bbsList = res.data.list;
            this.qiniu = res.data.qiniu_token;
          } else {
            this.bbsList = [];
          }
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    } else {
      getOrderServiceBBSList(params)
        .then((res) => {
          if (res.data) {
            this.bbsList = res.data.list;
            this.qiniu = res.data.qiniu_token;
          } else {
            this.bbsList = [];
          }
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    }
  }

  private beforeUploadUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
    };
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  private handleUploadSuccess(res: any) {
    this.bbsImage = res.key;
    this.bbsOrderSubmit(1);
  }

  private handleComplaintFinish() {
    let _this = this;
    this.$confirm('服务完成之后，投诉结束，双方将无法继续发送留言', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          order_id: _this.nowId,
          order_service_id: _this.nowSid,
          // 第一次投诉，状态设置为2
          complaint_state: 8
        };
        complain(params)
          .then((res) => {
            const item = {
              id: _this.nowId.valueOf(),
              stage: 8
            };
            ComplaintModule.switchStage(item);
            _this.close(true);
          })
          .catch((err) => {
            _this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  close(refresh?: boolean) {
    this.$emit('close', false, refresh);
  }

  private imgLarge(val: string) {
    let value = [val];
    let enlargedData = {
      isShow: true,
      imgList: value,
      initNum: 0
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
}
